import { getBetterAuthClient } from '@jbroll/rowboat-auth-betterauth-react';

// The one client for the whole app, and it must be the SAME instance useSession/useAuthor
// resolve (the rowboat package's getBetterAuthClient singleton). better-auth's session
// signal is per-client-instance, so a second createAuthClient() here would make signUp/
// signIn flip a signal nothing listens to — the session never reaches useSession and the
// app stays on the auth gate forever (no polling, and sign-up does not broadcast).
//
// The singleton targets the page origin (the Vite dev proxy, or wherever the app is
// served from). It does NOT honor VITE_AUTH_URL, unlike src/lib/syncToken.ts, which still
// mints against VITE_AUTH_URL. A non-proxied deploy that serves the app from one origin
// and the better-auth backend from another will break auth while token minting keeps
// pointing at the real backend.
export const betterAuthClient = getBetterAuthClient();
